export function counterMaxValue(cartItemCount: number) {
  return cartItemCount < 99 ? cartItemCount : '+99';
}
